// @ts-nocheck
import {Column} from 'react-table'
import {CustomHeader} from './CustomHeader'
import {CustonCell} from './CustonCell'
import {formatMask} from '../../../../../utils/formatMonetaryToBr'
import {formatDateTime} from '../../../../../utils/dayJs/format'
import {PaymentHeader} from './PaymentHeader'
import {ReportBonusSaleConfig} from '../../ReportBonusSaleConfig'

const createSummaryColumns = (config: ReportBonusSaleConfig): ReadonlyArray<Column<any>> => [
  {
    Header: (props) => <CustomHeader tableProps={props} title='Contrato' className='min-w-125px' />,
    id: 'contract',
    Cell: ({...props}) => (
      <CustonCell
        value={props.data[props.row.index].contract}
        showAlertIcons={config.showClientAlertIcons}
      />
    ),
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Status' className='min-w-125px' />,
    id: 'statusName',
    Cell: ({...props}) => (
      <CustonCell
        value={props.data[props.row.index].statusName}
        showAlertIcons={config.showClientAlertIcons}
      />
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Dt Contrato' className='min-w-125px' />
    ),
    id: config.dateField,
    Cell: ({...props}) => (
      <CustonCell
        value={formatDateTime(props.data[props.row.index][config.dateField])}
        showAlertIcons={config.showClientAlertIcons}
      />
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='nome cliente' className='min-w-125px' />
    ),
    id: 'client_name',
    Cell: ({...props}) => (
      <CustonCell
        value={props.data[props.row.index].clientName}
        activeAlert={props.data[props.row.index].activeAlert}
        alertObservation={props.data[props.row.index].alertObservation}
        showAlertIcons={config.showClientAlertIcons}
      />
    ),
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='unidade' className='min-w-125px' />,
    id: 'franchiseName',
    Cell: ({...props}) => (
      <CustonCell
        value={`${props.data[props.row.index].franchiseName}`}
        showAlertIcons={config.showClientAlertIcons}
      />
    ),
  },
  {
    Header: (props) => (
      <PaymentHeader tableProps={props} title='Formas de pagamento' className='min-w-125px' />
    ),
    id: 'payments',
    Cell: ({...props}) => (
      <CustonCell
        value={
          <div className='card-body py-3 mt-3'>
            <div className='table-responsive'>
              <table className='table table-bordered table-hover table-row-bordered table-row-gray-100'>
                <tbody>
                  {props?.data[props.row.index]?.payments?.map((item, index) => (
                    <tr key={`payments${index}`}>
                      <td>{item.paymentOptions}</td>
                      <td>{formatMask(item.price)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        }
        showAlertIcons={config.showClientAlertIcons}
      />
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Vr desconto' className='min-w-125px' />
    ),
    id: 'discount',
    Cell: ({...props}) => (
      <CustonCell
        value={formatMask(props.data[props.row.index].discount)}
        showAlertIcons={config.showClientAlertIcons}
      />
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Vr crédito voucher' className='min-w-125px' />
    ),
    id: 'voucherCredit',
    Cell: ({...props}) => (
      <CustonCell value={formatMask(props.data[props.row.index].voucherCredit)}
        showAlertIcons={config.showClientAlertIcons} />
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Vr total faturável' className='min-w-125px' />
    ),
    id: 'totalPrice',
    Cell: ({...props}) => (
      <CustonCell
        value={formatMask(props.data[props.row.index].totalPrice)}
        showAlertIcons={config.showClientAlertIcons}
      />
    ),
  },
]

const createDetailColumns = (config: ReportBonusSaleConfig): ReadonlyArray<Column<any>> => [
  {
    Header: (props) => <CustomHeader tableProps={props} title='Contrato' className='min-w-125px' />,
    id: 'contract',
    Cell: ({...props}) => (
      <CustonCell value={props.data[props.row.index].contract} showAlertIcons={false} />
    ),
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Status' className='min-w-125px' />,
    id: 'statusName',
    Cell: ({...props}) => (
      <CustonCell value={props.data[props.row.index].statusName} showAlertIcons={false} />
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Dt Contrato' className='min-w-125px' />
    ),
    id: config.dateField,
    Cell: ({...props}) => (
      <CustonCell
        value={formatDateTime(props.data[props.row.index][config.dateField])}
        showAlertIcons={false}
      />
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='nome cliente' className='min-w-125px' />
    ),
    id: 'client_name',
    Cell: ({...props}) => (
      <CustonCell
        value={props.data[props.row.index].clientName}
        activeAlert={props.data[props.row.index].activeAlert}
        alertObservation={props.data[props.row.index].alertObservation}
        showAlertIcons={config.showClientAlertIcons}
      />
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Unid Contrato' className='min-w-50px' />
    ),
    id: 'franchiseName',
    Cell: ({...props}) => (
      <CustonCell value={props.data[props.row.index].franchiseName} showAlertIcons={false} />
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Categoria' className='min-w-125px' />
    ),
    id: 'categoryName',
    Cell: ({...props}) => (
      <CustonCell value={props.data[props.row.index].categoryName} showAlertIcons={false} />
    ),
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Num Area' className='min-w-125px' />,
    id: 'productId',
    Cell: ({...props}) => (
      <CustonCell value={`${props.data[props.row.index].productId}`} showAlertIcons={false} />
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Desc Area' className='min-w-125px' />
    ),
    id: 'productName',
    Cell: ({...props}) => (
      <CustonCell value={`${props.data[props.row.index].productName}`} showAlertIcons={false} />
    ),
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Qte' />,
    id: 'sessions',
    Cell: ({...props}) => (
      <CustonCell value={props.data[props.row.index].sessions} showAlertIcons={false} />
    ),
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Tp' />,
    id: 'type',
    Cell: ({...props}) => (
      <CustonCell value={props.data[props.row.index].type} showAlertIcons={false} />
    ),
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Preco' className='min-w-125px' />,
    id: 'price',
    Cell: ({...props}) => (
      <CustonCell value={formatMask(props.data[props.row.index].price)} showAlertIcons={false} />
    ),
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Desconto' className='min-w-125px' />,
    id: 'discount',
    Cell: ({...props}) => (
      <CustonCell value={formatMask(props.data[props.row.index].discount)} showAlertIcons={false} />
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Credito Voucher' className='min-w-125px' />
    ),
    id: 'voucherCredit',
    Cell: ({...props}) => (
      <CustonCell value={formatMask(props.data[props.row.index].voucherCredit)} showAlertIcons={false} />
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Valor Total Faturavel' className='min-w-125px' />
    ),
    id: 'totalPrice',
    Cell: ({...props}) => (
      <CustonCell
        value={formatMask(props.data[props.row.index].totalPrice)}
        showAlertIcons={false}
      />
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Funcionario' className='min-w-125px' />
    ),
    id: 'sellerName',
    Cell: ({...props}) => (
      <CustonCell value={props.data[props.row.index].sellerName} showAlertIcons={false} />
    ),
  },
]

const createColumns = (config: ReportBonusSaleConfig): ReadonlyArray<Column<any>> => {
  if (config.reportType === 'summary') {
    return createSummaryColumns(config)
  }
  return createDetailColumns(config)
}

export {createColumns}
